<template>
<div>

	<div :class="containerClass" @click="onWrapperClick">
        <AppTopBar @menu-toggle="onMenuToggle"  :user="userData" v-if="userData" />

        <div class="layout-sidebar" @click="onSidebarClick" v-if="userData && userData.groups && (userData.groups.id == 1 || userData.groups.id == 4)" >
            <AppMenu :model="menu" @menuitem-click="onMenuItemClick"/>
        </div>
        <div class="layout-sidebar" @click="onSidebarClick" v-if="userData && userData.groups && (userData.groups.id == 5)" >
            <AppMenu :model="menu" @menuitem-click="onMenuItemClick"/>
        </div>
        <div class="layout-sidebar" @click="onSidebarClick" v-if="userData && userData.groups && userData.groups.id == 3" >
            <AppMenu :model="menuCalidad" @menuitem-click="onMenuItemClick"/>
        </div>
        <div class="layout-sidebar" @click="onSidebarClick" v-if="userData && userData.groups && userData.groups.id == 2" >
            <AppMenu :model="menuOperarios" @menuitem-click="onMenuItemClick"/>
        </div>
        <div class="layout-main-container">
            <div class="layout-main">
                <router-view />
            </div>
            <AppFooter />
        </div>

		<AppConfig :layoutMode="layoutMode" @layout-change="onLayoutChange" @change-theme="changeTheme" />
        <transition name="layout-mask">
            <div class="layout-mask p-component-overlay" v-if="mobileMenuActive"></div>
        </transition>
	</div>

</div>

</template>

<script>
import AppTopBar from './AppTopbar.vue';
import AppMenu from './AppMenu.vue';
import AppConfig from './AppConfig.vue';
import AppFooter from './AppFooter.vue';
import Login from './pages/Login.vue';
import UserService from "./services/user.service";

export default {
    emits: ['change-theme'],

    mounted() {
        if (!this.currentUser) {
            // disable for development
            this.$router.push('/operarios');
        }

    UserService.getUserBoard().then(
      (response) => {
        this.userData = response.data;
        console.log('this.userData')
        console.log(this.userData)
        if(this.userData && this.userData.groups && (this.userData.groups.id == 2 || this.userData.groups.id == 4)) {
            this.onMenuToggle();
        }
        if (this.userData) {
            let deposito = this.userData.roles.filter((item) => item.name == 'deposito');
            if (deposito.length > 0) {
                this.menu = [
                    {
                        items: [ 
                            {label: 'Inicio', icon: 'pi pi-fw pi-home', to: '/'},
                            {label: 'Insumos', icon: 'pi pi-fw pi-box', to: '/insumos' },
                            {label: 'Solic. Insumos', icon: 'pi pi-fw pi-box', to: 'solicitud-insumos' },
                            {label: 'Trazabilidad', icon: 'pi pi-fw pi-box', to: '/trazabilidad' },
                        ]
                    },
                    
                ]
            }
            let jefe = this.userData.roles.filter((item) => item.name == 'planta');
            if (jefe.length > 0) {
                this.menu = [
                    {
                        items: [ 
                            {label: 'Inicio', icon: 'pi pi-fw pi-home', to: '/'},
                            {label: 'PPP', icon: 'pi pi-fw pi-tablet', to: '/produccion' },
                            {label: 'Órden de Compra', icon: 'pi pi-fw pi-box', to: 'orden-compra' },
                            {label: 'Solic. Insumos', icon: 'pi pi-fw pi-box', to: 'solicitud-insumos' },
                            {label: 'Reporte Insumos', icon: 'pi pi-fw pi-box', to: 'reporte-insumos' },  
                            {label: 'Materiales', icon: 'pi pi-fw pi-table', to: '/material'},
                            {label: 'Unidades', icon: 'pi pi-fw pi-table', to: '/unidades'},
                            {label: 'Mantenimiento', icon: 'pi pi-fw pi-calendar', to: '/mantenimiento'},                          
                        ]
                    },
                    
                ]
            }
        }
      },
      (error) => {
        this.userData =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );



    },
    data() {
        return {
            isLogged: false,
            layoutMode: 'static',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
            userData: {},
            menuCalidad: [{
            items: [
                {label: 'Inicio', icon: 'pi pi-fw pi-home', to: '/'},
                {label: 'PPP', icon: 'pi pi-fw pi-tablet', to: '/produccion' },
                {label: 'Maquinaria', icon: 'pi pi-fw pi-share-alt', to: '/maquinaria'},
                {label: 'Materiales', icon: 'pi pi-fw pi-table', to: '/material'},
                {label: 'Unidades', icon: 'pi pi-fw pi-table', to: '/unidades'},
                {label: 'Mantenimiento', icon: 'pi pi-fw pi-calendar', to: '/mantenimiento'},
                ]
            }],
            menuOperarios: [{
            items: [
                {label: 'Inicio', icon: 'pi pi-fw pi-home', to: '/'},
                {label: 'Solic. Insumos', icon: 'pi pi-fw pi-box', to: 'solicitud-insumos' },
                ]
            }],
            menu : [
                {
                    //label: 'Panel',
                    // items: [{
                    //     label: 'Inicio', icon: 'pi pi-fw pi-home', to: '/'
                    // }]
                },
				{
					//label: 'Terceros', icon: 'pi pi-fw pi-sitemap',
					items: [
                        {label: 'Inicio', icon: 'pi pi-fw pi-home', to: '/'},
                        {label: 'PPP', icon: 'pi pi-fw pi-tablet', to: '/produccion' },
                        {label: 'Órden de Compra', icon: 'pi pi-fw pi-box', to: 'orden-compra' },
                        {label: 'Solic. Insumos', icon: 'pi pi-fw pi-box', to: 'solicitud-insumos' },
                        {label: 'Reporte Insumos', icon: 'pi pi-fw pi-box', to: 'reporte-insumos' },
                        {label: 'Productos', icon: 'pi pi-fw pi-list', to: '/productos' },
                        {label: 'Presupuestos', icon: 'pi pi-fw pi-file', to: '/presupuestos' },
                        {label: 'Proveedores', icon: 'pi pi-fw pi-list', to: '/proveedor'},
        				{label: 'Clientes', icon: 'pi pi-fw pi-list', to: '/cliente'},
                        {label: 'Depósitos', icon: 'pi pi-fw pi-map-marker', to: '/almacenes'},
                        {label: 'Insumos', icon: 'pi pi-fw pi-box', to: '/insumos' },
                        {label: 'Trazabilidad', icon: 'pi pi-fw pi-box', to: '/trazabilidad' },
                        {label: 'Metal Desplegado', icon: 'pi pi-fw pi-box', to: 'desplegados' },
                        {label: 'Mano de Obra', icon: 'pi pi-fw pi-user', to: '/manodeobra' },
						// {label: 'Maquinaria', icon: 'pi pi-fw pi-share-alt', to: '/maquinaria'},
						{label: 'Materiales', icon: 'pi pi-fw pi-table', to: '/material'},
                        {label: 'Unidades', icon: 'pi pi-fw pi-table', to: '/unidades'},
                        // {label: 'Mantenimiento', icon: 'pi pi-fw pi-calendar', to: '/mantenimiento'},
                        // //{label: 'Logística ', icon: 'pi pi-fw pi-directions', to: '/logistica'},
                        // //{label: "Cotizaciones", icon: "pi pi-fw pi-dollar", to: "/cotizaciones"},
                        {label: 'Configuraciones', icon: 'pi pi-fw pi-cog',
                            items: [
                                {label: 'Variables globales', icon: 'pi pi-fw pi-percentage', to: '/configuraciones'},
                                {label: 'Tipos de Cliente', icon: 'pi pi-fw pi-users', to: '/tipos-de-cliente'},
                                {label: 'Condic. de Venta', icon: 'pi pi-fw pi-dollar', to: '/condiciones-de-venta'},
                                {label: 'Zonas', icon: 'pi pi-fw pi-map-marker', to: '/zonas'},
                                {label: 'Transportes', icon: 'pi pi-fw pi-directions', to: '/transportes'},
                                {label: 'Sectores', icon: 'pi pi-fw pi-map-marker', to: '/sectores'},                                
                                ]
                        },
                        {label: 'Usuarios', icon: 'pi pi-fw pi-users', to: '/usuario' },
                        {label: 'Planos', icon: 'pi pi-fw pi-file', to: '/planos' }
 
					]
				},                
            ]
            }
        },
        watch: {
            $route() {
                this.menuActive = false;
                this.$toast.removeAllGroups();
            }
        },
        created() {

        },
    methods: {
        onWrapperClick() {
            if (!this.menuClick) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }

            this.menuClick = false;
        },
        onMenuToggle() {
            this.menuClick = true;

            if (this.isDesktop()) {
                if (this.layoutMode === 'overlay') {
					if(this.mobileMenuActive === true) {
						this.overlayMenuActive = true;
					}

                    this.overlayMenuActive = !this.overlayMenuActive;
					this.mobileMenuActive = false;
                }
                else if (this.layoutMode === 'static') {
                    this.staticMenuInactive = !this.staticMenuInactive;
                }
            }
            else {
                this.mobileMenuActive = !this.mobileMenuActive;
            }

            //event.preventDefault();
        },
        onSidebarClick() {
            this.menuClick = true;
        },
        onMenuItemClick(event) {
            if (event.item && !event.item.items) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }
        },
		onLayoutChange(layoutMode) {
			this.layoutMode = layoutMode;
		},
        addClass(element, className) {
            if (element.classList)
                element.classList.add(className);
            else
                element.className += ' ' + className;
        },
        removeClass(element, className) {
            if (element.classList)
                element.classList.remove(className);
            else
                element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        isDesktop() {
            return window.innerWidth >= 992;
        },
        isSidebarVisible() {
            if (this.isDesktop()) {
                if (this.layoutMode === 'static')
                    return !this.staticMenuInactive;
                else if (this.layoutMode === 'overlay')
                    return this.overlayMenuActive;
            }

            return true;
        },
        changeTheme(event) {
            this.$emit('change-theme', event);
        }
    },
    computed: {
        containerClass() {
            return ['layout-wrapper', {
                'layout-overlay': this.layoutMode === 'overlay',
                'layout-static': this.layoutMode === 'static',
                'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                'layout-mobile-sidebar-active': this.mobileMenuActive,
				'p-input-filled': this.$primevue.config.inputStyle === 'filled',
				'p-ripple-disabled': this.$primevue.config.ripple === false
            }];
        },
        logo() {
            return (this.$appState.darkTheme) ? "images/logo.jpeg" : "images/logo.jpeg";
        },
        loggedIn() {
            return this.$store.state.auth.status.loggedIn;
        },
        currentUser() {
            return this.$store.state.auth.user;
        }
    },
    beforeUpdate() {
        if (this.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    },
    components: {
        'AppTopBar': AppTopBar,
        'AppMenu': AppMenu,
        'AppConfig': AppConfig,
        'AppFooter': AppFooter,
        'Login': Login,
    }
}
</script>

<style lang="scss">
@import './App.scss';

.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
    background: #0b3b5a;
    border-color: #041f30;
    color: #fff;
}

</style>
